import React, { useEffect } from 'react'
import chatBot from 'src/assets/images/chatBot.svg'
import chatbotPic from 'src/assets/images/cb1.svg'
import 'src/App.css'
import { useSelector } from 'react-redux'
import keycloak from 'src/utils/commonMethods/keycloak'
import { invokeAllTypesSXP } from 'src/services/individualService'

const LoadSxpChat = () => {
  const projId = process.env.REACT_APP_GET_SXP_PROJECT_ID
  const userInfo = useSelector((state) => state?.userInfo)

  const invokeSXP = async (sxpBody) => {
    await invokeAllTypesSXP(sxpBody, userInfo?.userName, 'choosePolicy')
  }

  useEffect(() => {
    const sxpBody = {
      state: {
        roles: userInfo?.userInfo?.userData?.roles,
      },
      userId: userInfo?.userName,
    }
    let mainObj = {
      socketUrl: process?.env?.REACT_APP_SOCKET_URL, // sxp URL
      socketPath: process?.env?.REACT_APP_SOCKET_PATH,
      SSL: true, // secure connection, true for https, false for http
      accessToken: `Bearer ${keycloak?.token}`,
      currentProject: projId, // name of the project / client you are working on / for
      fileServerUrl: process?.env?.REACT_APP_CHAT_FILE_SERVER_URL,
      mainTitle: 'Ask HITA',
      titleLogo: chatbotPic,
      customLauncher: chatBot,
      subTitle:
        '<span>Hi!</span> I am Hita, your personal assistant to help you with insurance-related queries. You can select from the options below.',
      chatRefresh: true,
      autoLaunch: false,
      lazyAutoLaunch: false,
      editChat: false,
      uploadDoc: true,
      defaultMessage: 'Welcome to Trovity',
      languages: [],
      initialImg:
        'https://paisaplan.s3.ap-south-1.amazonaws.com/dev/public/emailTemplateIcons/sxp_initial.png',
      version: localStorage.getItem('version'),
      journeyTray: false,
      fieldInputPlaceholder: 'Enter your Message here...',
      closeIcon: {
        showClose: true,
        imgUrl:
          'https://paisaplan.s3.ap-south-1.amazonaws.com/dev/public/emailTemplateIcons/closebutton.png',
      },
    }
    window.embedSXPChat(mainObj)

    invokeSXP(sxpBody).then(() => {
      setTimeout(() => {
        document.getElementsByClassName('sxp_js_chat_closeBtn')[0].click()
      }, 1000)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projId, userInfo?.userName])
  return <></>
}

export default LoadSxpChat
